import { create } from 'zustand'

/**
 * Φωτεινό ή σκοτεινό θέμα.
 *
 * Προεπιλογή είναι ό,τι έχει το λειτουργικό: όποιος έχει βάλει το κινητό του
 * σε σκοτεινό το περιμένει και εδώ. Η ρητή επιλογή κρατιέται τοπικά, ανά
 * συσκευή, γιατί είναι θέμα οθόνης και όχι λογαριασμού.
 */
export type Theme = 'system' | 'light' | 'dark'

export const THEMES: Theme[] = ['system', 'light', 'dark']

const STORAGE_KEY = 'b2vend.theme'
const media = window.matchMedia('(prefers-color-scheme: dark)')

function readStored(): Theme {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'light' || value === 'dark' ? value : 'system'
  } catch {
    return 'system'
  }
}

function apply(theme: Theme) {
  const dark = theme === 'dark' || (theme === 'system' && media.matches)
  document.documentElement.classList.toggle('dark', dark)
}

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const useTheme = create<ThemeState>((set) => ({
  theme: readStored(),
  setTheme: (theme) => {
    try {
      if (theme === 'system') localStorage.removeItem(STORAGE_KEY)
      else localStorage.setItem(STORAGE_KEY, theme)
    } catch {
      /* ιδιωτική περιήγηση: η επιλογή ισχύει μόνο για αυτή τη συνεδρία */
    }
    apply(theme)
    set({ theme })
  },
}))

/** Καλείται μία φορά πριν το πρώτο render, ώστε να μην αναβοσβήσει λευκό. */
export function initTheme() {
  apply(useTheme.getState().theme)
  media.addEventListener('change', () => {
    if (useTheme.getState().theme === 'system') apply('system')
  })
}
